import { DetailPage, Row } from "../../components/crud/DetailPage"
import { ListPage } from "../../components/crud/ListPage"
import { TextInput } from "../../components/forms/Inputs"
import { useTranslations } from "../../layers/Localization"

function CodesFields({ item, set }) {
    const t = useTranslations()
    return <>
        <Row>
            <TextInput className="grow" label={t("Code")} value={item.code} onChange={set('code')} required />
            <TextInput className="grow" label={t("Pour")} value={item.pour} onChange={set('pour')} />
        </Row>
    </>
}

export function CodesList(props) {
    const t = useTranslations()
    return <ListPage model="codes" title={t("Codes")} columns={{
        [t('Code')]: 'code',
        [t('Pour')]: 'pour',
    }} {...props} />
}

export function CodesDetail(props) {
    const t = useTranslations()
    return <DetailPage model="codes" title={t("Code")} Fields={CodesFields} {...props} />
}
